import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Home.css";
import servicesData from "./servicesData";

function Home() {
  const navigate = useNavigate();

  // Show only 6 services for a balanced grid
  const featuredServices = servicesData.slice(0, 6);

  return (
    <>
      {/* Hero Section */}
      <div className="hero">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline 
          className="hero-video"
        >
          <source src="/original/solar_4.mp4" type="video/mp4" />
        </video>
        <div className="overlay"></div>
        <div className="content">
          <h1>Professional Security Solutions Across the Midlands</h1>
          <h2>
            SIA Licensed Security Officers &amp; <span className="highlight">Expert Protection</span> for Your Business
          </h2>
          <p>
            Trusted security professional services for businesses across the Midlands. From construction site guarding to door supervisor services,
            we deliver comprehensive protection tailored to your needs.
          </p>
          <div className="buttons">
            <button className="btn primary" onClick={() => navigate("/contact")}>
              GET A FREE QUOTE
            </button>
            <button className="btn secondary" onClick={() => navigate("/services")}>
              VIEW ALL SERVICES
            </button>
          </div>
        </div>
      </div>

      {/* About Section */}
      <section className="about-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-tag">ABOUT US</span>
            <h2>Observant Security - Your Trusted Security Provider</h2>
            <p className="section-description">
              Observant Security Solution is a professional, service-driven security company
              dedicated to providing reliable solutions across the Midlands. As leading specialists in
              <span className="highlight-text"> Solar Panel Security</span> and renewable energy asset protection, 
              we focus on safeguarding your property, people, and premises with elite SIA licensed personnel.
            </p>
          </div>
          <div className="about-cards">
            <div className="about-card">
              <div className="card-icon">
                <img src="/Pages%20Images/CIA_Licensed.png" alt="SIA Licensed Security Officers" loading="lazy" />
              </div>
              <h3>SIA Licensed Security Officers</h3>
              <p>All our security personnel are fully SIA licensed and professionally trained to the highest standards.</p>
            </div>
            <div className="about-card">
              <div className="card-icon">
                <img src="/Pages%20Images/tailored_Sol.png" alt="Integrated Security Solutions" loading="lazy" />
              </div>
              <h3>Integrated Security Solutions</h3>
              <p>Specialist static guarding for comprehensive site protection across the Midlands.</p>
            </div>
            <div className="about-card">
              <div className="card-icon">
                <img src="/Pages%20Images/247Avalilability.png" alt="Availability" loading="lazy" />
              </div>
              <h3>Reliable Availability</h3>
              <p>Consistent security services with rapid response times across the Midlands.</p>
            </div>
            <div className="about-card">
              <div className="card-icon">
                <img src="/Pages%20Images/ExperiencedTeam.png" alt="Fast-Growing Company" loading="lazy" />
              </div>
              <h3>Fast-Growing Company</h3>
              <p>Committed to excellence in providing tailored security solutions to diverse industries across the Midlands.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Showcase */}
      <section className="services-showcase">
        <div className="section-container">
          <div className="section-header">
            <span className="section-tag">OUR SERVICES</span>
            <h2>Comprehensive Security Solutions</h2>
            <p className="section-description">
              We deliver a wide range of security solutions to suit the needs of your business.
              Our guards have protected construction sites, building sites, retail premises, and many more.
            </p>
          </div>
          <div className="services-grid">
            {featuredServices.map((service, index) => (
              <Link to={`/service/${index}`} key={index} className="service-card">
                <div className="service-image">
                  <img src={service.image} alt={service.title} loading="lazy" />
                  <div className="service-overlay"></div>
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <span className="service-arrow">Learn More →</span>
                </div>
              </Link>
            ))}
          </div>
          <div className="view-all-services buttons">
            <button className="btn primary" onClick={() => navigate("/services")}>
              VIEW ALL SERVICES
            </button>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="statistics-section">
        <div className="section-container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">MIDLANDS</div>
              <div className="stat-label">Operations across the Midlands</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client Satisfaction Guaranteed</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">RAPID</div>
              <div className="stat-label">Response Protection</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">LICENSED</div>
              <div className="stat-label">SIA Licensed Security Officers</div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Served */}
      <section className="industries-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-tag">INDUSTRIES WE SERVE</span>
            <h2>Protecting Businesses Across All Sectors</h2>
          </div>
          <div className="industries-grid">
            <div className="industry-card">
              <div className="industry-icon">
                <img src="/Pages%20Images/Construction_icon_Home_page.png" alt="Construction Site" loading="lazy" decoding="async" />
              </div>
              <h3>Construction Site</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <img src="/Pages%20Images/Construction_icon_Home_page.png" alt="Building Site" loading="lazy" decoding="async" />
              </div>
              <h3>Building Site</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <img src="/Services/24.solarfarms.png" alt="Solar Panel" loading="lazy" decoding="async" />
              </div>
              <h3>Solar Panel</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <img src="/Pages%20Images/Retaild_icon_Home_page.png" alt="Retail Security" loading="lazy" decoding="async" />
              </div>
              <h3>Retail Security</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <img src="/Pages%20Images/Event_icon_Home_page.png" alt="Door Supervisor" loading="lazy" decoding="async" />
              </div>
              <h3>Door Supervisor</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <img src="/Pages%20Images/Corporate_icon_Home_page.png" alt="Corporate" loading="lazy" decoding="async" />
              </div>
              <h3>Corporate</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Accreditations section removed as requested */}

      {/* Call to Action */}
      <section className="cta-section">
        <div className="section-container">
          <div className="cta-content">
            <h2>Ready to Secure Your Business?</h2>
            <p>Contact us today for a free, no-obligation security consultation</p>
            <div className="cta-buttons">
              <button className="btn primary large" onClick={() => navigate("/contact")}>
                GET A FREE QUOTE
              </button>
              <a href="tel:+447446084868" className="btn secondary large">
                📞 Call +44 7446 084868
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
